import store from '../redux/store';
import MixPanelService from '../system/services/MixPanelService';
import { handleABTestVersion } from './ABTestFunction';
import { getABVersion, getUniversityId, isGlobalVersionTwo, isUniGroup } from './Helpers';
import { localStorageWrapper, sessionStorageWrapper } from './storageFactory';

export const afterSearch = (noResults = false) => {
    try {
        if (sessionStorageWrapper.getItem('searchData')) {
            const searchData = JSON.parse(sessionStorageWrapper.getItem('searchData'));
            MixPanelService.track(searchData.trackName, {
                university_id: !isUniGroup() ? getUniversityId() : null,
                group_id: isUniGroup() ? getUniversityId() : null,
                'No search results': noResults,
                'Search term': searchData.value,
            });
            sessionStorageWrapper.removeItem('searchData');
        }
    } catch (err) {
        // TODO: handle error?
    }
};

export const trackCompletedFirstStep = (userData, universityId, onGroupChat, type) => {
    try {
        const { testBucket: ABTEST_1_BUCKET } = handleABTestVersion({ testName: 'ABTEST_1' });
        const { testBucket: ABTEST_2_BUCKET } = handleABTestVersion({ testName: 'ABTEST_2' });

        let place = 'undefined';
        if (onGroupChat) {
            place = 'Group Chat';
        } else if (localStorageWrapper.getItem('cameFromData')) {
            const cameFromData = JSON.parse(localStorageWrapper.getItem('cameFromData'));
            if (cameFromData.type === 'profile') {
                place = cameFromData.from === 'page' ? 'Profile page' : 'Profile card';
            } else if (cameFromData.type === 'post') {
                place = 'Posts';
            } else if (cameFromData.type === 'faq') {
                place = 'FAQs';
            } else if (cameFromData.type === 'like-post') {
                place = cameFromData.from === 'homePage' ? 'Home tab - Post Like' : 'Post paage Post Like';
            } else if (cameFromData.type === 'like-faq') {
                place =
                    cameFromData.from === 'homePage'
                        ? 'Home tab - FAQ Like'
                        : cameFromData.from === 'page'
                        ? 'FAQ page FAQ Like'
                        : 'FAQ tab FAQ Like';
            }
        }
        MixPanelService.track('Completed Step 1', {
            Name: userData.first_name + ' ' + userData.last_name,
            'Login with Google': type === 'google',
            'Login with Facebook': type === 'facebook',
            'Login via SSO': type === 'sso',
            'Login via Tiktok': type === 'tiktok',
            'Login via form': type === 'email',
            place: place,
            THE: isGlobalVersionTwo,
            university_id: universityId,
            ABTEST_1_BUCKET,
            ABTEST_2_BUCKET,
        });
    } catch (err) {
        // TODO: handle error?
    }
};

export const trackCompletedRegistration = (
    dataFirstStep,
    universityId,
    onGroupChat,
    socialType,
    isMarketingChecked,
    onForumChat
) => {
    try {
        const { testBucket: ABTEST_1_BUCKET } = handleABTestVersion({ testName: 'ABTEST_1' });
        const { testBucket: ABTEST_2_BUCKET } = handleABTestVersion({ testName: 'ABTEST_2' });

        let place = 'undefined';
        if (onForumChat) {
            place = 'Forum Chat Tab';
        } else if (localStorageWrapper.getItem('cameFromData')) {
            const cameFromData = JSON.parse(localStorageWrapper.getItem('cameFromData'));
            if (cameFromData.type === 'post') {
                place = cameFromData.from === 'page' ? 'Content post page' : 'Home tab - Content post';
            } else if (cameFromData.type === 'faq') {
                place =
                    cameFromData.from === 'homePage'
                        ? 'Home tab - FAQ'
                        : cameFromData.from === 'page'
                        ? 'FAQ page'
                        : 'FAQ tab';
            } else if (cameFromData.type === 'profile') {
                place =
                    cameFromData.from === 'homePage'
                        ? 'Home tab - Ambassador profile'
                        : cameFromData.from === 'page'
                        ? 'Ambassador profile page'
                        : 'Ambassador profile tab';
            } else if (cameFromData.type === 'group-chat') {
                place = cameFromData.from === 'homePage' ? 'Home tab - Group Chat' : 'Group Chat tab';
            } else if (cameFromData.type === 'stream') {
                place = cameFromData.from === 'homePage' ? 'Home tab - Streams' : 'Streams tab';
            } else if (cameFromData.type === 'like-post') {
                place = cameFromData.from === 'homePage' ? 'Home tab - Post Like' : 'Post paage Post Like';
            } else if (cameFromData.type === 'like-faq') {
                place =
                    cameFromData.from === 'homePage'
                        ? 'Home tab - FAQ Like'
                        : cameFromData.from === 'page'
                        ? 'FAQ page FAQ Like'
                        : 'FAQ tab FAQ Like';
            }
        }

        MixPanelService.track('Completed Registration', {
            Name: dataFirstStep.first_name + ' ' + dataFirstStep.last_name,
            'Marketing consent': isMarketingChecked,
            'Login with Google': socialType === 'google',
            'Login with Facebook': socialType === 'facebook',
            'Login via SSO': socialType === 'sso',
            'Login via Tiktok': socialType === 'tiktok',
            'Login via form': socialType === 'email',
            place: place,
            THE: isGlobalVersionTwo,
            university_id: universityId,
            ABTEST_1_BUCKET,
            ABTEST_2_BUCKET,
        });
    } catch (err) {
        // TODO: handle error?
    }
};

export const seeMoreTrigger = (type = 'users', triggerPoint = 'Button') => {
    const accountInfo = store.getState().account.account_info;

    let eventName = "Used 'See more profile cards'";
    if (type === 'posts') {
        eventName = "Used 'See more posts'";
    } else if (type === 'faqs') {
        eventName = "Used 'See more FAQs'";
    } else if (type === 'chats') {
        eventName = "Used 'See more group chats'";
    } else if (type === 'liveStreams') {
        eventName = "Used 'See more streams'";
    } else if (type === 'forum') {
        eventName = "Used 'See more forum'";
    }
    MixPanelService.track(eventName, {
        university_id: !isUniGroup() ? getUniversityId() : null,
        group_id: isUniGroup() ? getUniversityId() : null,
        'Starting point': triggerPoint,
        Prospect: accountInfo ? 'registered' : 'unregistered',
        Version: getABVersion(),
    });

    if (type === 'posts') {
        viewContentTrigger('See more posts');
    }
};

export const viewContentTrigger = (triggerPoint = 'Other') => {
    const accountInfo = store.getState().account.account_info;

    MixPanelService.track('View Content tab', {
        university_id: !isUniGroup() ? getUniversityId() : null,
        group_id: isUniGroup() ? getUniversityId() : null,
        'Starting point': triggerPoint,
        Prospect: accountInfo ? 'registered' : 'unregistered',
        Version: getABVersion(),
    });
};

export const trackMixpanelEvent = ({ name, description, additionalConfig = {} }) => {
    MixPanelService.track(description, {
        university_id: getUniversityId(),
        name,
        ...additionalConfig,
    });
};
